// Copyright (C) 2019 TANNER AG

import React from "react";
import { Switch, Route } from "react-router-dom";
import TranslationProvider from "./translation";
import Entry from "./entry";
import { TypeConfiguration, ModuleConfiguration, DefaultParameterConfiguration } from "./configuration";
import Result from "./result";
import Footer from "./components/footer";
import "./index.css";

const TCO = (props) => (
	<TranslationProvider>
		<div
			style={{
				display: 'flex',
				flex: '1 0 auto',
				marginLeft: 'auto',
				marginRight: 'auto',
				maxWidth: 1200,
				width: '100%'
			}}
		>
			<Switch>
				<Route path={props.match.path + "/"} exact component={Entry}/>
				<Route path={props.match.path + "/defaultparameters"} component={DefaultParameterConfiguration}/>
				<Route path={props.match.path + "/type"} component={TypeConfiguration}/>
				<Route path={props.match.path + "/configuration"} component={ModuleConfiguration}/>
				<Route path={props.match.path + "/result"} component={Result}/>
			</Switch>
		</div>
		<Footer/>
	</TranslationProvider>
);

export default TCO;



// WEBPACK FOOTER //
// ./src/tco/index.js